import React from "react";
import { Controls, IFormStyles, useFormStyles } from "..";
import { FormGroup, FormGroupProps, FormGroupType } from "../misc/formGroup";

interface FormCurrencyProps extends Controls.ControlCurrencyProps {
    isLoading?: boolean | undefined
    label?: string | undefined
    groupType?: FormGroupType | undefined;
    labelWidth?: string | undefined;
}

const ComponentProps = (props: FormCurrencyProps): Controls.ControlCurrencyProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.groupType;
    delete componentProps.labelWidth;

    delete componentProps.label;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    return componentProps;
}

const GroupProps = (props: FormCurrencyProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: props.groupType,
        labelWidth: props.labelWidth,

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };

    return groupProps;
}

export const FormCurrency: React.FC<Controls.ControlCurrencyProps> = (props) => {
    const styles: IFormStyles = useFormStyles();

    return (
        <FormGroup  {...GroupProps(props)}>
            <Controls.ControlCurrency {...ComponentProps(props)} controlStyles={styles.control} />
        </FormGroup>
    );
};
